import { c as _c } from "react/compiler-runtime";
import { type Metric } from '@/payload/payload.types';
import { Transition } from '@headlessui/react';
import { Notification } from '@tallinn-arvudes/ui/tallinn-design/Notification';
import { cn } from '@tallinn-arvudes/ui/utils';
import React, { useEffect } from 'react';
export const MetricWarning = t0 => {
  const $ = _c(21);
  const {
    metric,
    className
  } = t0;
  let t1;
  if ($[0] !== metric.activeStatus || $[1] !== metric.isValid) {
    t1 = () => {
      const messages = [];
      if (metric.activeStatus === "inactive") {
        messages.push("See m\xF5\xF5dik ei ole aktiivne");
      }
      if (!metric.isValid) {
        messages.push("See m\xF5\xF5dik ei vasta n\xF5uetele");
      }
      return messages;
    };
    $[0] = metric.activeStatus;
    $[1] = metric.isValid;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const getMetricNotification = t1;
  let t2;
  if ($[3] !== getMetricNotification) {
    t2 = getMetricNotification();
    $[3] = getMetricNotification;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  const messages_0 = t2;
  const [showNotification, setShowNotification] = React.useState(false);
  let t3;
  let t4;
  if ($[5] !== messages_0.length) {
    t3 = () => {
      setShowNotification(!!messages_0.length);
    };
    t4 = [messages_0.length];
    $[5] = messages_0.length;
    $[6] = t3;
    $[7] = t4;
  } else {
    t3 = $[6];
    t4 = $[7];
  }
  useEffect(t3, t4);
  let t5;
  if ($[8] !== className) {
    t5 = cn("opacity-100 z-10 transition-opacity data-[closed]:opacity-0", className);
    $[8] = className;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== messages_0) {
    t6 = <>See mõõdik ei ole avalikult nähtav, sest:<ul className="list-disc ml-10">{messages_0.map(_temp)}</ul></>;
    $[10] = messages_0;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  let t7;
  if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = () => setShowNotification(false);
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  let t8;
  if ($[13] !== t6) {
    t8 = <Notification variant="danger" title={t6} onDismiss={t7} isDismissible={true} />;
    $[13] = t6;
    $[14] = t8;
  } else {
    t8 = $[14];
  }
  let t9;
  if ($[15] !== t5 || $[16] !== t8) {
    t9 = <div className={t5}>{t8}</div>;
    $[15] = t5;
    $[16] = t8;
    $[17] = t9;
  } else {
    t9 = $[17];
  }
  let t10;
  if ($[18] !== showNotification || $[19] !== t9) {
    t10 = <Transition show={showNotification}>{t9}</Transition>;
    $[18] = showNotification;
    $[19] = t9;
    $[20] = t10;
  } else {
    t10 = $[20];
  }
  return t10;
};
function _temp(message, index) {
  return <li key={index}>{message}</li>;
}